<template>
  <RevCard>
    <h3 class="heading-3 mb-16 p-16">
      {{ i18n(translations.title) }}
    </h3>

    <RevTable :collection="orderDetails.orderLines" :columns transparent-header>
      <template #body-sku="{ item }">
        <span class="max-w-[400px] break-all">{{ item.sku }}</span>
      </template>
      <template #body-appearance="{ item }">
        <RevTag :label="item.appearance.label" variant="secondary" />
      </template>
      <template #body-grade="{ item }">
        <RevTag :label="item.grade.label" variant="secondary" />
      </template>
      <template #body-price="{ item }">
        {{ i18n.price(item.priceWithTaxes) }}
      </template>
    </RevTable>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevTable } from '@ds/components/Table'
import { RevTag } from '@ds/components/Tag'

import type { OrderDetails } from '../../OrderDetails.types'

import translations from './OrderLinesItems.translations'

defineProps<{ orderDetails: OrderDetails }>()

const i18n = useI18n()

const columns = [
  { key: 'id', label: i18n(translations.lineItemNumber), isTabular: true },
  { key: 'sku', label: i18n(translations.sku) },
  { key: 'productName', label: i18n(translations.item) },
  { key: 'appearance', label: i18n(translations.appearance) },
  { key: 'grade', label: i18n(translations.grade) },
  { key: 'quantity', label: i18n(translations.quantity) },
  { key: 'itemIdentifier', label: i18n(translations.imeiOrSerialNumber) },
  { key: 'price', label: i18n(translations.price), isTabular: true },
]
</script>
